import { Component } from '@angular/core';

@Component({
    selector: 'kui-header-nav',
    templateUrl: './header-nav.component.html',
    standalone: false
})
export class KuiHeaderNavComponent { }
